import { useCallback } from 'react';
import { isValid, format } from 'date-fns';

import { useDateTimePickerFormatterProps } from './useDateTimePickerFormatter.types';

export const useDateTimePickerFormatter = ({
  setState,
  onChange,
  formatPattern,
}: useDateTimePickerFormatterProps) => {
  return useCallback(
    (newValue: Date | null) => {
      setState(newValue);
      if (newValue instanceof Date && isValid(newValue)) {
        onChange(format(newValue, formatPattern));
      }
    },
    [setState, onChange, formatPattern],
  );
};
